import defaultPage from '@/sections/system/default-page.vue';
import companyBasePage from '@/sections/system/company-base-page.vue';
import requireContext from '@/utils/require-context';

const routes = [
	{
		path: '/',
		name: 'default',
		component: defaultPage
	},
	{
		path: '/company/:companyid',
		name: 'company-base',
		props: route => ({ companyId: parseInt(route.params.companyid) }),
		component: companyBasePage,
		children: []
	}
];

const companyBaseRoute = routes.find(r => {
	return r.name == 'company-base';
});

// Import all of the routes files.
function loadRoutes() {
	let context;

	if (process.env.NODE_ENV === 'test') {
		//when running jest, there's no webpack require
		context = requireContext('../', true, /.*-routes\.js$/i);
	} else {
		context = require.context('../', true, /.*-routes\.js$/i);
	}

	return context
		.keys()
		.map(context) // import module
		.map(m => m.default); // get `default` export from each resolved module
}

const resourceRoutes = loadRoutes();
resourceRoutes.forEach(routearray => {
	let companyRoutes = routearray.filter(r => {
		var result = true;

		if (
			Object.prototype.hasOwnProperty.call(r, 'meta') &&
			Object.prototype.hasOwnProperty.call(r.meta, 'notCompanyRoute') &&
			r.meta.notCompanyRoute
		) {
			result = false;
		}

		return result;
	});

	companyBaseRoute.children.push(...companyRoutes);

	let nonCompanyRoutes = routearray.filter(r => {
		var result = false;

		if (
			Object.prototype.hasOwnProperty.call(r, 'meta') &&
			Object.prototype.hasOwnProperty.call(r.meta, 'notCompanyRoute') &&
			r.meta.notCompanyRoute
		) {
			result = true;
		}

		return result;
	});

	routes.push(...nonCompanyRoutes);
});

export default routes;
